// Paleta categórica validada (ordem fixa, nunca ciclada dentro de um mesmo
// gráfico) — usada para donuts com poucas categorias (gênero, ativo/inativo).
export const CATEGORICAL_PALETTE = [
    '#2a78d6', // blue
    '#eb6834', // orange
    '#1baf7a', // aqua
    '#eda100', // yellow
    '#e87ba4', // magenta
    '#008300', // green
    '#4a3aa7', // violet
    '#e34948', // red
];

// Hue único para gráficos de série/barra simples (magnitude).
export const SERIES_COLOR = CATEGORICAL_PALETTE[0];

export const CHART_GRID_COLOR = '#e1e0d9';
export const CHART_MUTED_TEXT = '#898781';

// Rampa sequencial (hue único azul, claro→escuro) para magnitude contínua
// (choropleth, heatmap) — steps 100→700 do design system validado.
export const SEQUENTIAL_BLUE = [
    '#cde2fb', '#b7d3f6', '#9ec5f4', '#86b6ef', '#6da7ec', '#5598e7',
    '#3987e5', '#2a78d6', '#256abf', '#1c5cab', '#184f95', '#104281', '#0d366b',
];

// Preenchimento neutro para categorias sem dado no período (ex.: estado sem pedidos).
export const MAP_NO_DATA_FILL = '#eeece2';
export const MAP_BORDER_COLOR = '#fcfcfb';
